<template>
  <div id="app">
    <headmenu />
    <router-view/>
    <Footer />
  </div>
</template>

<style lang="scss">
  @import '@/styles/style.scss';
</style>

<script>
import headmenu from '@/components/headmenu';
import Footer from '@/components/footer';
import scrollingActions from '@/util/scrollingActions';

export default {
  name: 'app',
  components: {
    headmenu, 
    Footer,
  },
  methods: {

  },
  async mounted() {
    scrollingActions();
    window.onload = () => { scrollingActions(); };
    window.onscroll = () => { scrollingActions(); };
  },
};
</script>
